import React, { useEffect, useState } from "react";
import { FormulaModal, PowerPermission } from "../modal";
import { Button, Modal, message } from "antd";
import { SettingIcon, ReTryIcon } from "../Icons";
import "./function.css";
import { useGlobal } from "../../global/user";
import { Power } from "../../api";
import axios from "axios";

export default function Function9({ machineID, data, machineInfo, setStatus }) {
  const { user } = useGlobal();
  const { field_mobile_id } = data;
  const [A, setA] = useState(data.a || 1);
  const [B, setB] = useState(data.b || 0);
  const [onEdit, setOnEdit] = useState(false);
  const [onOrOff, setOnOrOff] = useState("--");
  const [current, setCurrent] = useState("--");
  const [leakageCurrent, setLeakageCurrent] = useState("--");
  const [temperature, setTemperature] = useState("--");
  const [editPermission, setEditPermission] = useState(false);
  const [permissionID, setPermissionID] = useState(1);
  const [passwords, setPasswords] = useState([data.password1, data.password2, data.password3, data.password4, data.password5]);
  const [names, setNames] = useState([data.name1, data.name2, data.name3, data.name4, data.name5]);
  const { IP, port, name } = machineInfo;
  const [isRestarting, setIsRestarting] = useState(false);

  useEffect(async () => {
    try {
      const response = await axios.get(`https://${IP}:${port}/init_stat?nodeID=1`);
      response.status === 200 ? setStatus(1) : setStatus(0);
      setTimeout(async () => {
        const res = await Power.PowerGetData(IP, port);
        res.onOrOff == 1 ? setOnOrOff("ON") : setOnOrOff("OFF");
        setCurrent(res.current);
        setLeakageCurrent(res.leakageCurrent);
        setTemperature(res.temperature);
      }, 1000);
    } catch {
      setStatus(0);
    }
  }, []);
  const calculate = (value) => {
    if (typeof value == "number") return Math.round((A * parseFloat(value) + B) * 100) / 100;
    return "--";
  };

  const ReloadData = () => {};

  const ReloadConfirm = () =>
    Modal.confirm({
      title: `確認刷新`,
      content: `確認刷新電源 ${name} `,
      onOk: ReloadData,
    });

  const openEditPermission = async () => {
    setEditPermission(true);
  };

  const powerRestart = async () => {
    setIsRestarting(true);
    try {
      let response = await Power.PowerRestart();
      if (response.data?.overall_success) {
        message.success(`編號：${machineID} 電源控制重啟成功`);
      } else {
        console.error(`編號：${machineID} 電源控制重啟失敗`, response);
        message.error(`編號：${machineID} 電源控制重啟失敗`);
      }
    } catch (err) {
      console.error(`編號：${machineID} 電源控制重啟失敗:`, err);
      message.error(`編號：${machineID} 電源控制重啟失敗`);
    } finally {
      setIsRestarting(false);
    }
  };

  return (
    <React.Fragment>
      <td>
        <div className="d-flex justify-content-center py-2">
          <div style={{ width: "90%" }}>
            <div className="d-flex justify-content-between">
              <div>
                <span className="font-weight-bold mr-1">{`編號:`}</span>
                <span className="mr-2 text-nowrap">{`${machineID}`}</span>
              </div>
              <div>
                <span className="font-weight-bold mr-1">{`開關:`}</span>
                <span className="mr-2 text-nowrap">{`${onOrOff}`}</span>
              </div>
              <div>
                <span className="font-weight-bold mr-1">{`電流:`}</span>
                <span className="mr-2 text-nowrap">{`${calculate(current)}`}</span>
              </div>
              <div>
                <span className="font-weight-bold mr-1">{`漏電流:`}</span>
                <span className="mr-2 text-nowrap">{`${calculate(leakageCurrent)}`}</span>
              </div>
              <div>
                <span className="font-weight-bold mr-1">{`溫度:`}</span>
                <span className="mr-2 text-nowrap">{`${calculate(temperature)}`}</span>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-2">
              <button className="control_setting" onClick={ReloadConfirm}>
                <ReTryIcon className="button_svg control_svg" />
              </button>
              {user.class >= process.env.REACT_APP_EDITOR_CALSS_LV && (
                <>
                  <button className="control_setting ml-2" onClick={() => setOnEdit(true)}>
                    <SettingIcon className="button_svg control_svg" />
                  </button>
                  <Button style={{height: 40, fontWeight:500, marginLeft:5}} onClick={openEditPermission}>
                    編輯權限
                  </Button>
                  <Button
                    style={{ height: 40, fontWeight: 500, marginLeft: 5 }}
                    onClick={powerRestart}
                    loading={isRestarting}
                    disabled={isRestarting}
                  >
                    電源控制重啟
                  </Button>
                </>
              )}
            </div>
            <FormulaModal visible={onEdit} setA={setA} setB={setB} A={A} B={B} data={data} setVisible={setOnEdit} type="電源" />
            <PowerPermission
              visible={editPermission}
              machineID={machineID}
              machineInfo={machineInfo}
              field_mobile_id={field_mobile_id}
              passwords={passwords}
              setPasswords={setPasswords}
              permissionID={permissionID}
              setPermissionID={setPermissionID}
              names={names}
              setNames={setNames}
              setEditPermission={setEditPermission}
            />
          </div>
        </div>
      </td>
    </React.Fragment>
  );
}
